module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAANABADASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAwQHCP/EACQQAAEDBAAGAwAAAAAAAAAAAAECAxEEBQYhAAgTMUFRBxIU/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AK5fufy9Y/kDlteFrd6QWFLQyoAkAfQyVaBJI7HQnzwSwc8uQ5zcnaS0hllxDK3C3+fqKTCok67EbnwdT7yhmWAM5FltZcV1zzDlQtK1NoSCmYHvfj3w/hXx03jNbU1VPc6g1CWFMJWW2yIJIOlJUJg9+A//2Q=="


//////////////////
// WEBPACK FOOTER
// ./static/Resized_Images/1470066081.jpg
// module id = 4XuH
// module chunks = 1